<template>
  <div :class="type == 'popover' ? 'cellphone__popover' : 'cellphone__wrapper'">
    <img :src="phoneImage" alt="cellphone" class="cellphone" />

    <div>
      <div class="overlap" auto>
        <div class="text" :class="{ preview: preview }">
          <CustomScrollbar class="text-scroll" ref="scrollRef" auto>
            <FilePreviewCard
              v-if="templateType !== WhatsappTemplateTypes.Text"
              :preview="preview"
              :templateType="templateType"
              :file="file"
              :mediaLink="mediaLink"
            />

            <div class="html-content" v-html="state ? reactiveContentFormated : content"></div>
            <!-- {{ state ? reactiveContent : content }} -->
          </CustomScrollbar>
          <span class="time">14:15</span>
        </div>
        <div class="group" v-if="buttons">
          <div v-if="buttons.length > 0">
            <div
              class="button"
              v-for="(button, index) of buttons"
              :key="button.text"
              :class="button.text && 'active'"
            >
              <IconPhoneCall
                v-if="button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber &&
                button.callOutput !== WhatsappTemplateTypeCall.WhatsappVoice"
                :active="button.text"
              />
              <IconPhoneCall
                v-if="(button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber || 
                WhatsappTemplateTypeSpecificButtons.VoiceCall) && 
                button.callOutput === WhatsappTemplateTypeCall.WhatsappVoice"
                :active="button.text"
              />
              <IconExternalLink
                v-if="button.type === WhatsappTemplateTypeSpecificButtons.Url"
                :active="button.text"
              />
              <IconReply
                :active="button.text"
                v-if="button.type === WhatsappTemplateTypeButtons.QuickReply"
              />
              <CopyOutlined
                style="font-size: 16px"
                v-if="button.type === WhatsappTemplateTypeSpecificButtons.OTP"
              />
              {{ button.text === null ? `Botón ${index + 1}` : button.text }}
            </div>
          </div>
        </div>
        <div class="group" v-else>
          <div v-if="templateButton === WhatsappTemplateButtons.WithButton" class="button">
            <template v-if="templateCategory === WhatsappTemplateCategories.OTP">
              <CopyOutlined />

              Copiar código
            </template>

            <template v-else>Botón 1</template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch, inject, computed } from "vue";
import { CopyOutlined } from "@ant-design/icons-vue";
import { cloneDeep } from "lodash";

import {
  WhatsappTemplateTypes,
  WhatsappTemplateButtons,
  WhatsappTemplateTypeSpecificButtons,
  WhatsappTemplateTypeButtons,
  WhatsappTemplateCategories,
  WhatsappTemplateTypeCall,
} from "@/app/channels/utils/enums";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import FilePreviewCard from "../molecules/FilePreviewCard.vue";
import IconExternalLink from "@/app/common/components/atoms/IconExternalLink.vue";
import IconPhoneCall from "@/app/common/components/atoms/IconPhoneCall.vue";
import IconReply from "@/app/common/components/atoms/IconReply.vue";

import phoneImage from "@/app/workspace/assets/whatsapp-phone.svg?url";

export default defineComponent({
  components: {
    CustomScrollbar,
    IconExternalLink,
    IconPhoneCall,
    FilePreviewCard,
    IconReply,
    CopyOutlined,
  },
  props: {
    /**
     * State is the formState with the parameters, this parameters must be in the next format:
     *
     * {
     *   1: param1Value,
     *   2: param2Value,
     *   ...
     * }
     */
    state: {
      required: false,
      default: null,
    },
    content: {
      required: false,
      type: String,
    },
    buttons: {
      required: false,
      type: Array,
    },
    buttonType: {
      required: false,
      type: String,
    },
    preview: {
      default: false,
      type: Boolean,
    },
    templateType: [Number, String],
    templateCategory: String,
    file: {
      type: File,
      default: null,
    },
    mediaLink: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: "normal", // popover
    },
    formatted: {
      type: Boolean,
      default: false,
    },
    triggerScroll: {  // actualizar valor para subir el scroll al inicio
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const scrollRef = ref(null);
    const reactiveContent = ref(props.content);

    const templateButton = inject("templateButton");

    const type = ref(props.type);

    watch(props.state, (newState) => {
      reactiveContent.value = props.content;
      for (const num in newState) {
        const singleParamRegex = new RegExp(`{{[${num}]}}`);

        const initialContentArray = reactiveContent.value.split(" ");
        const paramIdx = initialContentArray.findIndex((word) => singleParamRegex.test(word));
        // const contentArray = reactiveContent.value.split(" ");
        const contentArray = cloneDeep(initialContentArray);
        if (paramIdx !== -1) {
          const newParamText = initialContentArray[paramIdx].replace(
            singleParamRegex,
            newState[num] || `{{${num}}}`
          );

          contentArray[paramIdx] = newParamText;
          reactiveContent.value = contentArray.join(" ");
        }
      }
    });
    watch(
      () => props.buttons,
      (newButtons) => {
        console.log("Buttons changed:", newButtons);
      }
    );

    watch(
      () => props.triggerScroll,
      () => {
        scrollRef.value?.scrollToTop();
      }
    );

    const reactiveContentFormated = computed(() => {
      if (props.formatted) {
        return reactiveContent.value
          .replace(/(?<!\w)\*([^\s*][^*]*?)\*(?!\w)/gmu, "<strong>$1</strong>")
          .replace(/(?<!\w)_([^\s_][^_]*?)_(?!\w)/gmu, "<em>$1</em>")
          .replace(/(?<!\w)~([^\s~][^~]*?)~(?!\w)/gmu, "<del>$1</del>")
          .replace(/```([\s\S]*?)```/g, "<code>$1</code>");
      }
      return reactiveContent.value;
    });

    return {
      WhatsappTemplateCategories,
      WhatsappTemplateTypes,
      reactiveContent,
      scrollRef,
      WhatsappTemplateButtons,
      WhatsappTemplateTypeSpecificButtons,
      WhatsappTemplateTypeButtons,
      WhatsappTemplateTypeCall,
      templateButton,
      phoneImage,
      reactiveContentFormated,
    };
  },
});
</script>

<style lang="sass" scoped>
.cellphone
  width: 100%
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.35)
  border-radius: 22px

  &__wrapper
    position: relative
    width: 100%
    height: 100%

  &__popover.template-preview
    width: auto !important

.overlap
  color: $gray-8
  line-height: 22px
  position: absolute
  top: 18%
  right: 5%
  left: 5%
  height: auto
  max-height: 68%
  display: flex
  flex-direction: column
  overflow: hidden
  .text
    text-align: left !important
    word-break: break-word
    overflow-wrap: anywhere
    display: flex
    flex-direction: column
    flex: 1
    min-height: 0
    padding: 5px 10px
    background: white
    border-radius: 20px
    box-shadow: 0px 0.5px 2px rgba(0, 0, 0, 0.25)
    margin-bottom: 10px
    &.preview
      color: $gray-6
  .button
    color: $gray-6
    padding: 5px 10px
    background: white
    border-radius: 20px
    box-shadow: 0px 0.5px 2px rgba(0, 0, 0, 0.25)
    text-align: center
    margin-bottom: 8px
    display: flex
    align-items: center
    justify-content: center
    gap: 10px
  .active
    color: #1677FF
  .text-scroll
    flex: 1
    overflow-x: hidden
    width: 100%

    .html-content
      text-align: left

  .group
    flex-shrink: 0
  .time
    color: $gray-7
    width: 100%
    display: block
    text-align: right
    font-size: 12px

.cellphone__popover .overlap .text
  font-size: 12px
  color: $gray-8
  line-height: 20px

:deep(.ps__rail-y)
  opacity: 0.6

:deep(.ps__rail-x)
  display: none !important
</style>
